import React from 'react';

import { LoanBanner } from '.';

export const PaidOffBanner: React.FC = () => (
  <LoanBanner style='success'>
    <span><strong>Congratulations!</strong> Your loan has been paid off.</span>
  </LoanBanner>
);
